<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="operationId" :confirm="askConfirm" :params="{operationId:this.operationId}"
                    :title="$t('New') + ' ' + $t('contrat')" route-back="OperationShowInvestor"/>
        <back-arrow v-else-if="investorContratId !== null" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('l') + ' ' + $t('contrat')" route-back="InvestorContratIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('New') + ' ' + $t('contrat')"
                    route-back="InvestorContratIndex"/>
      </div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div class="row">
            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.name.invalidFeedback"
                :label="$t('contrat.name.label')"
                :state="form.name.state"
                class="medium-label mb-4"
                label-for="name-input">
                <b-form-input
                  id="name-input"
                  v-model="form.name.value"
                  :state="form.name.state"
                  maxlength="250"
                  required
                  :disabled="investorContratId && !canChangeName"
                  type="text"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.operation.invalidFeedback"
                :label="$t('Operation')"
                :state="form.operation.state"
                class="medium-label mb-4"
                label-for="operation-input">
                <b-input-group>
                  <b-form-select
                    id="operation-input"
                    v-model="form.operation.value"
                    :state="form.operation.state"
                    required
                    @change="manageDateOpe($event)">
                    <option v-for="(operation, index) in operations" :key="index" :value="index">
                      {{ $t(operation.tostring) }}
                    </option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>

            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.initialPayment.invalidFeedback"
                :label="$t('contrat.initialPayment.label')"
                :state="form.initialPayment.state"
                class="medium-label mb-4"
                label-for="initial-payment-input">
                <b-form-input
                  id="initial-payment-input"
                  v-model="form.initialPayment.value"
                  v-disable-scroll
                  :state="form.initialPayment.state"
                  required
                  type="number"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.datePayment.invalidFeedback"
                :label="$t('contrat.datePayment.label')"
                :state="form.datePayment.state"
                class="medium-label mb-4"
                label-for="date-payment-input">
                <datepicker-input
                  id="date-payment-input"
                  v-model="form.datePayment.value"
                  :state="form.datePayment.state"
                  required
                  @input="removeInvalidFeedback('datePayment')"
                  @change="removeInvalidFeedback('datePayment')">
                </datepicker-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.rendement.invalidFeedback"
                :label="$t('contrat.rendement.label')"
                :state="form.rendement.state"
                class="medium-label mb-4"
                label-for="rendement-input">
                <b-form-input
                  id="rendement-input"
                  v-model="form.rendement.value"
                  v-disable-scroll
                  :state="form.rendement.state"
                  required
                  step="0.1"
                  type="number"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.deadline.invalidFeedback"
                :label="$t('contrat.deadline.label')"
                :state="form.deadline.state"
                class="medium-label mb-4"
                label-for="deadline-input">
                <datepicker-input
                  id="deadline-input"
                  v-model="form.deadline.value"
                  :state="form.deadline.state"
                  required
                  @input="removeInvalidFeedback('deadline')"
                  @change="removeInvalidFeedback('deadline')">
                </datepicker-input>
              </b-form-group>
            </div>

          </div>

          <div v-if="investorContratId !== null" class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../../components/b122/BackArrow";
import api from "../../../services/api";
import DatepickerInput from '../../../components/b122/editFields/DatepickerInput';

export default {
  name: "InvestorContratCreateEdit",

  components: {
    backArrow,
    DatepickerInput
  },

  data() {
    return {
      investorContratId: this.$route.params.investorContratId,
      operationId: this.$route.params.operationId,
      askConfirm: false,
      operations: [],
      canChangeName: true,
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        initialPayment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        datePayment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        rendement:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        deadline:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        operation:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    selectedOperation() {
      return this.operations.find(operation => operation.id === this.form.operation.value) || null;
    }
  },

  methods: {

    manageDateOpe(indexOpe) {
      let ope = this.operations[indexOpe];
    },

    async fetchData() {
      if (this.operationId) {
        await this.fetchOperation()
      } else {
        await this.fetchAllOperations()
      }
      if (this.investorContratId) {
        await this.fetchContrat()
      }
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          if (response.data.bilanType === "EXE") {
            var newOpeExe = {
              id: response.data.id,
              bilanType: "EXE",
              tostring: response.data.tostring + " - EXE",
            }
            this.operations.push(newOpeExe)
            this.form.operation.value = 0 //index
          } else {
            var newOpeAvp = {
              id: response.data.id,
              bilanType: "AVP",
              tostring: response.data.tostring + " - AVP",
            }
            this.operations.push(newOpeAvp)
            this.form.operation.value = 0
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchContrat() {
      await api
        .get(`/investorContrat/${this.investorContratId}`)
        .then(response => {
          this.form.name.value = response.data.name
          this.form.initialPayment.value = Number(response.data.initialPayment / 100)
          this.form.datePayment.value = new Date(response.data.datePayment).toLocaleDateString().split("/").reverse().join("-")
          this.form.rendement.value = response.data.rendement
          this.form.deadline.value = new Date(response.data.deadline).toLocaleDateString().split("/").reverse().join("-")
          this.canChangeName = response.data.canChangeName

          this.form.operation.value = this.operations.findIndex(operation => {
            return operation.id === response.data.operation.id && operation.bilanType === response.data.bilanType;
          });


        })
    },


    async fetchAllOperations() {
      await api
        .get('/operation/getAllAuthorizedOperations')
        .then(response => {
          var operationsData = response.data

          operationsData.forEach((operation) => {
            var newOpe = {
              id: operation.id,
              tostring: operation.tostring + " - AVP",
              bilanType: "AVP",
            }
            this.operations.push(newOpe)
            if (operation.availableBilanType.length > 1) {
              var newOpeExe = {
                id: operation.id,
                bilanType: "EXE",
                tostring: operation.tostring + " - EXE",
              }
              this.operations.push(newOpeExe)
            }
          });
        })
    },

    async onSubmit() {
      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('initialPayment', this.form.initialPayment.value)
      if(this.form.datePayment.value){
        data.append('datePayment', this.form.datePayment.value)
      }
      data.append('rendement', this.form.rendement.value)
      if(this.form.deadline.value){
        data.append('deadline', this.form.deadline.value)
      }
      let operation = this.operations[this.form.operation.value]
      data.append('operationId', operation.id)
      data.append('bilanType', operation.bilanType)

      let url = 'investorContrat'
      if (this.investorContratId) {
        url = '/investorContrat/' + this.investorContratId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(async (response) => {
          await this.generateMonthlyCharges()
          if (this.operationId) {
            this.$router.push({
              name: 'OperationShowInvestor',
              params: {
                operationId: this.operationId
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast(this.form.name.value)
              })
            })
          } else {
            this.$router.push({
              name: 'InvestorShow',
              params: {
                investorContratId: response.data.id
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast(this.form.name.value)
              })
            })
          }

        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'InvestorContratIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback (field) {
      this.askConfirm = true
      this.form[field]['state'] = null
    },


    successToast(investorContratName) {
      this.$bvToast.toast(this.$i18n.t('Contrat') + ' "' + investorContratName + '" ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      let operation = this.operations[this.form.operation.value]
      data.append('operationId', operation.id)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

  }
}
</script>

<style scoped>
.input-group-append {
  padding: 0 !important;
  border: none !important;
  border-radius: 0 4px 4px 0;
  border-left: none;
}
</style>



// WEBPACK FOOTER //
// src/views/investor/investorContrat/InvestorContratCreateEdit.vue